import { formatDate as e, formatDateShort as t } from "../lib/formatDate.es.js";
import { Fragment as n, jsx as r } from "react/jsx-runtime";
// lib/Factbox/components/FactboxModified.tsx
var i = ({ modified: i = "", modifiedLabel: a, locale: o = "en", absolute: s = !1 }) => {
	if (i) {
		let n = s ? t(i) : e(i, o);
		return /* @__PURE__ */ r("div", {
			className: "opacity-70 font-semibold text-[11px] flex justify-between items-center gap-1 w-full",
			children: /* @__PURE__ */ r("div", { children: `${a ?? "Original is from"} ${n}` })
		});
	}
	return /* @__PURE__ */ r(n, {});
};
export { i as FactboxModified };
